<script setup lang="ts">
    import type { IWidgetProps } from '~/composables/widgets';
    import type { ShopInfoPlacementData } from '~/@types/cms';

    const appStore = useAppStore();

    const { shopInfo } = storeToRefs(appStore);

    /**
     * ShopInfoPlacement fetches data from the website configuration containing the required ShopInfoSnippet
     */

    const props = defineProps<IWidgetProps<ShopInfoPlacementData>>();

    const snippet = computed(() => {
        const dataCode = props.data.code;
        if (!dataCode) {
            return undefined;
        }
        const snippetData = shopInfo.value?.find((i: any) => i.code === dataCode.trim());
        if (!snippetData?.text) return;
        return snippetData.text as WidgetContent<any>;
    });

    // validate data here and perform additional async calls if required
</script>
<template>
    <atm-grid
        class="cms-shop-info-placement my-2"
        v-if="snippet"
        no-margin>
        <div class="col-span-2 md:col-span-12">
            <cms-content-controller
                :data="snippet"
                class="no-grid" />
        </div>
    </atm-grid>
</template>
